import { gql } from "graphql-request";

const SERVER_DELETE_VARIABLES = gql`
  mutation DeleteVariable($id: ID!) {
  deleteVariable(id: $id)
}
`;
export default SERVER_DELETE_VARIABLES;
